export const blockIconsUiactionsAppsNew = (
	<span className='material-symbols-outlined'>apps</span>
);
